import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CSSProperties, ReactElement } from 'react';
import { UserRole } from 'src/config/api/models/User';

export type BannerTypes = 'demo' | 'default' | 'local' | 'production';
export interface Banner {
  isDemoMode?: boolean;
  showBanner: boolean;
  bannerContent?: ReactElement;
  messageStart?: string;
  messageEnd?: string;
  url?: string;
  urlDescription?: string;
  targetRoles?: UserRole[];
  locations?: string[];
  maxPathSize?: number;
  justifyContent?: CSSProperties['justifyContent'];
  type?: BannerTypes;
}

const initialState: Banner = {
  showBanner: false,
  maxPathSize: 4,
  justifyContent: 'center',
  type: 'default',
};

const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  reducers: {
    setBannerState: (state, action: PayloadAction<Banner>) => {
      const newState = { ...state, ...action.payload };
      return newState;
    },
    resetBanner: () => initialState,
  },
});

export const { setBannerState, resetBanner } = bannerSlice.actions;

export const { reducer: bannerReducer } = bannerSlice;
